<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import { Rive, Fit, Layout } from '@rive-app/canvas'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import HeaderTag from '@components/services/HeaderTag.vue'
import GlobalHero from '@sections/global/Hero.vue'

gsap.registerPlugin(ScrollTrigger)

let tl

const width = ref(0)
const canvas = ref(null)
const scrollProgress = ref(0)

onMounted(() => {
	// const crownRive = new Rive({
	// 	canvas: canvas.value,
	// 	src: 'https://cdn.papercrowns.com/website/rive/lockups/services.riv',
	// 	autoplay: true,
	// 	layout: new Layout({
	// 		fit: Fit.Contain,
	// 	}),
	// 	stateMachines: 'crownsStateMachine',
	// 	// onLoad: () => {
	// 	// 	let vmi = crownRive.viewModelInstance
	// 	// 	const booleanProperty = vmi.boolean('isHovered')
	// 	// 	booleanProperty.value = true
	// 	// },
	// })

	tl = gsap.timeline({
		scrollTrigger: {
			start: 'top top',
			end: '+=400',
			scrub: 1,
			markers: false,
			// ease: 'power2.out',
			onUpdate({ progress }) {
				scrollProgress.value = Number(progress.toFixed(2))
				width.value = 50 + progress * 80
			},
		},
	})

	gsap.set('.tag-wrap', {
		scale: 0,
		opacity: 0,
		rotation: () => gsap.utils.random(-10, 10),
	})

	tl.to(
		'.tag-wrap',
		{
			scale: 1,
			opacity: 1,
			rotation: 0,
			duration: 0.6,
			ease: 'power2.out',
			stagger: 0.3,
		},
		0.5,
	)
})

onUnmounted(() => {
	tl?.revert()
})
</script>

<template>
	<GlobalHero :rive="{ src: 'https://cdn.papercrowns.com/website/rive/lockups/services.riv', height: 512, width: 1411 }" titleSvg="https://cdn.papercrowns.com/website/images/elements/lockups/services.svg" />
	<!--
	<div class="fixed flex w-full items-center bg-crowns-off-black pb-5 pt-28 lg:py-28">
		<div class="container">
			<div class="flex justify-center">
				<img class="max-h-44 lg:mb-10 xl:h-48 xl:max-h-none 2xl:h-52 3xl:h-56" src="https://cdn.papercrowns.com/website/images/elements/lockups/services.svg" alt="Services" />
			</div>
		</div>
		<div class="absolute flex h-full w-full items-center bg-gradient-to-t from-crowns-off-black via-transparent to-transparent sm:via-crowns-off-black/50">
			<div class="container">
				<div class="relative flex flex-col items-center justify-center gap-5 lg:mb-10">
					<img class="absolute bottom-0 left-0 hidden h-8 lg:block" src="https://cdn.papercrowns.com/website/images/elements/lockups/visionaries-rewriting.svg" alt="Visionaries Rewriting the Scripts of Reality" />
					<img class="absolute bottom-0 right-0 hidden w-12 lg:block" src="https://cdn.papercrowns.com/website/images/elements/lockups/crowns-2019-90.svg" alt="Paper Crowns, Established 2019" />
					<canvas class="-mt-24 h-[34rem]" height="900" width="2000" ref="canvas" />

					<img class="max-h-60 md:mt-5 xl:h-64 xl:max-h-none 2xl:h-72 3xl:h-80" src="https://cdn.papercrowns.com/website/images/elements/lockups/services-etches.png" alt="Etches" />
				</div>
			</div>
		</div>
	</div> -->

	<div class="relative overflow-hidden">
		<!-- <div class="h-[16.5rem] xs:h-[18rem] sm:h-[20rem] md:h-[22.5rem] xl:h-[24.5rem] 2xl:h-[26.5rem] 3xl:h-[28.5rem]"></div> -->
		<div class="relative flex justify-center bg-crowns-off-black">
			<div id="bg-container" class="container absolute h-full w-full min-w-full bg-crowns-dark-grey lg:min-w-0" :style="`min-width:${width}%;`"></div>
			<div class="relative w-full">
				<div class="container">
					<div class="flex w-full items-center justify-center py-10 lg:pb-24 lg:pt-20">
						<div class="relative lg:w-8/12">
							<img class="-ml-3 w-full" src="https://cdn.papercrowns.com/website/images/elements/lockups/master-of-all-trades.png" alt="Turning trade into expertise" />
							<div class="tag-wrap absolute right-0 top-[10%] hidden md:block"><HeaderTag class="-rotate-[10deg] hover:!-rotate-6" hash="web-design-dev">Web Design &amp; Development</HeaderTag></div>
							<div class="tag-wrap absolute left-[10%] top-[20%] hidden md:block"><HeaderTag class="-rotate-12 hover:!-rotate-6" hash="brand-identity">Brand Identity</HeaderTag></div>
							<div class="tag-wrap absolute right-[25%] top-[37.5%] hidden md:block"><HeaderTag class="rotate-[9deg] hover:!rotate-6" hash="animation-renders">Animation</HeaderTag></div>
							<div class="tag-wrap absolute left-[40%] top-[50%] hidden md:block"><HeaderTag class="-rotate-3 hover:!rotate-3" hash="production">Production</HeaderTag></div>
							<div class="tag-wrap absolute bottom-[30%] right-[5%] hidden md:block"><HeaderTag class="rotate-[10deg] hover:!rotate-6" hash="brand-identity">And Many More...</HeaderTag></div>
							<div class="tag-wrap absolute bottom-[17.5%] left-[30%] hidden md:block"><HeaderTag class="-rotate-[6deg] hover:!-rotate-12" hash="streaming">Streaming</HeaderTag></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style>
@media (max-width: 1024px) {
	#bg-container {
		min-width: 100% !important;
	}
}
</style>
